import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "invite-page" }
const _hoisted_2 = { class: "invite-card" }
const _hoisted_3 = { class: "invite-brand" }
const _hoisted_4 = { class: "invite-brand-name" }
const _hoisted_5 = {
  key: 0,
  class: "invite-state"
}
const _hoisted_6 = {
  key: 1,
  class: "invite-state invite-state--error"
}
const _hoisted_7 = {
  key: 2,
  class: "invite-state invite-state--success"
}
const _hoisted_8 = { class: "invite-header" }
const _hoisted_9 = { class: "invite-sub" }
const _hoisted_10 = { class: "role-chip" }
const _hoisted_11 = { class: "invite-email-row" }
const _hoisted_12 = { class: "invite-form" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = { class: "field" }
const _hoisted_15 = { class: "field" }
const _hoisted_16 = ["min", "max"]
const _hoisted_17 = { class: "field" }
const _hoisted_18 = { class: "pw-wrap" }
const _hoisted_19 = ["type"]
const _hoisted_20 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_21 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_22 = {
  key: 0,
  class: "field-error"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "spinner-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("svg", {
          width: "32",
          height: "32",
          viewBox: "0 0 32 32",
          fill: "none"
        }, [
          _createElementVNode("rect", {
            width: "32",
            height: "32",
            rx: "8",
            fill: "var(--accent,#2563eb)"
          }),
          _createElementVNode("path", {
            d: "M8 24L16 8l8 16",
            stroke: "#fff",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }),
          _createElementVNode("path", {
            d: "M10.5 19h11",
            stroke: "#fff",
            "stroke-width": "2",
            "stroke-linecap": "round"
          })
        ], -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.systemName), 1)
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("div", { class: "spinner" }, null, -1),
            _createElementVNode("p", null, "Verificando convite…", -1)
          ]))]))
        : (_ctx.loadError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[9] || (_cache[9] = _createElementVNode("svg", {
                width: "40",
                height: "40",
                viewBox: "0 0 40 40",
                fill: "none"
              }, [
                _createElementVNode("circle", {
                  cx: "20",
                  cy: "20",
                  r: "18",
                  stroke: "#ef4444",
                  "stroke-width": "2"
                }),
                _createElementVNode("path", {
                  d: "M20 12v10M20 26v2",
                  stroke: "#ef4444",
                  "stroke-width": "2.5",
                  "stroke-linecap": "round"
                })
              ], -1)),
              _cache[10] || (_cache[10] = _createElementVNode("h2", null, "Convite inválido", -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.loadError), 1)
            ]))
          : (_ctx.accepted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[11] || (_cache[11] = _createElementVNode("svg", {
                  width: "48",
                  height: "48",
                  viewBox: "0 0 48 48",
                  fill: "none"
                }, [
                  _createElementVNode("circle", {
                    cx: "24",
                    cy: "24",
                    r: "22",
                    stroke: "#22c55e",
                    "stroke-width": "2"
                  }),
                  _createElementVNode("path", {
                    d: "M14 24l7 7 13-14",
                    stroke: "#22c55e",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)),
                _cache[12] || (_cache[12] = _createElementVNode("h2", null, "Conta criada!", -1)),
                _cache[13] || (_cache[13] = _createElementVNode("p", null, "Sua conta foi criada com sucesso. Você já pode fazer login.", -1)),
                _createElementVNode("button", {
                  class: "btn-primary",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goLogin && _ctx.goLogin(...args)))
                }, "Ir para o login")
              ]))
            : (_ctx.invite)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[16] || (_cache[16] = _createElementVNode("h1", null, "Você foi convidado!", -1)),
                    _createElementVNode("p", _hoisted_9, [
                      _cache[14] || (_cache[14] = _createTextVNode("Crie sua conta em ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.invite.systemName), 1),
                      _cache[15] || (_cache[15] = _createTextVNode(" como ", -1)),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.roleLabel(_ctx.invite.role)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[17] || (_cache[17] = _createElementVNode("svg", {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      fill: "none"
                    }, [
                      _createElementVNode("rect", {
                        x: "1",
                        y: "3",
                        width: "14",
                        height: "10",
                        rx: "2",
                        stroke: "currentColor",
                        "stroke-width": "1.3"
                      }),
                      _createElementVNode("path", {
                        d: "M1 5l7 5 7-5",
                        stroke: "currentColor",
                        "stroke-width": "1.3"
                      })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.invite.email), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[18] || (_cache[18] = _createElementVNode("label", null, "Nome completo", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name) = $event)),
                        type: "text",
                        placeholder: "Seu nome",
                        autocomplete: "name"
                      }, null, 512), [
                        [_vModelText, _ctx.form.name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[19] || (_cache[19] = _createElementVNode("label", null, "Username", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.username) = $event)),
                        type: "text",
                        placeholder: "Ex: joaosilva",
                        autocomplete: "username"
                      }, null, 512), [
                        [_vModelText, _ctx.form.username]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[20] || (_cache[20] = _createElementVNode("label", null, "Data de nascimento", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.birthDate) = $event)),
                        type: "date",
                        min: _ctx.MIN_BIRTH_DATE,
                        max: _ctx.maxBirthDate(),
                        autocomplete: "bday",
                        required: ""
                      }, null, 8, _hoisted_16), [
                        [_vModelText, _ctx.form.birthDate]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", null, "Senha", -1)),
                      _createElementVNode("div", _hoisted_18, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.password) = $event)),
                          type: _ctx.showPw ? 'text' : 'password',
                          placeholder: "Mín. 8 caracteres, 1 número",
                          autocomplete: "new-password"
                        }, null, 8, _hoisted_19), [
                          [_vModelDynamic, _ctx.form.password]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "pw-toggle",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showPw = !_ctx.showPw))
                        }, [
                          (!_ctx.showPw)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_20, [...(_cache[21] || (_cache[21] = [
                                _createElementVNode("path", {
                                  d: "M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z",
                                  stroke: "currentColor",
                                  "stroke-width": "1.3"
                                }, null, -1),
                                _createElementVNode("circle", {
                                  cx: "8",
                                  cy: "8",
                                  r: "2",
                                  stroke: "currentColor",
                                  "stroke-width": "1.3"
                                }, null, -1)
                              ]))]))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_21, [...(_cache[22] || (_cache[22] = [
                                _createElementVNode("path", {
                                  d: "M1 1l14 14M6.5 6.7A2 2 0 0 0 9.3 9.5M3.7 3.9C2.2 5 1 8 1 8s2.5 5 7 5c1.4 0 2.7-.4 3.8-1M6 2.2C6.6 2.1 7.3 2 8 2c4.5 0 7 5 7 5s-.7 1.5-2 2.8",
                                  stroke: "currentColor",
                                  "stroke-width": "1.3",
                                  "stroke-linecap": "round"
                                }, null, -1)
                              ]))]))
                        ])
                      ])
                    ]),
                    (_ctx.submitError)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.submitError), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "btn-primary",
                      disabled: _ctx.submitting,
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                    }, [
                      (_ctx.submitting)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.submitting ? 'Criando conta…' : 'Criar conta'), 1)
                    ], 8, _hoisted_23)
                  ])
                ], 64))
              : _createCommentVNode("", true)
    ])
  ]))
}